import React, { useState, useEffect } from 'react';
import axios from 'axios';
import "../../Styles/FacultyTicketHistory.css";
import Loader from "../../Components/Loader";


function FacultyTicketHistory() {
    const [openTickets, setOpenTickets] = useState([]);
    const [closedTickets, setClosedTickets] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Fetch the ticket history when the component mounts
        const token = localStorage.getItem("authToken");
        const fetchTicketHistory = async () => {
            try {
                const response = await axios.get("https://api.uniums.com/api/tickets/faculty-ticket-history", {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                const tickets = response.data.history;
                setOpenTickets(tickets.filter(ticket => ticket.status === "open" || ticket.status === "in-progress"));
                setClosedTickets(tickets.filter(ticket => ticket.status === "resolved" || ticket.status === "closed"));
            } catch (error) {
                console.error("Error fetching ticket history:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchTicketHistory();
    }, []);

    return (
        <div className="ticket-history-container">
            <h1>Ticket History</h1>
            {loading ? (
                <Loader /> 
            ) : (
                <>
                    <div className="ticket-section-history">
                        <h2>Open Tickets</h2>
                        <div className="ticket-list-history">
                            {openTickets.length > 0 ? (
                                openTickets.map((ticket) => (
                                    <div key={ticket._id} className="ticket-card-history open-ticket">
                                        <h3>{ticket.subject}</h3>
                                        <p>{ticket.description}</p>
                                        <p>Status: {ticket.status}</p>
                                        <span>
                                            Issue Date & Time: &nbsp;
                                            {new Intl.DateTimeFormat("en-US", {
                                                dateStyle: "medium",
                                                timeStyle: "short",
                                            }).format(new Date(ticket.createdAt))}
                                        </span>

                                    </div>
                                ))
                            ) : (
                                <p>No open tickets at the moment.</p>
                            )}
                        </div>
                    </div>

                    <div className="ticket-section-history">
                        <h2>Resolved/Closed Tickets</h2>
                        <div className="ticket-list-history">
                            {closedTickets.length > 0 ? (
                                closedTickets.map((ticket) => (
                                    <div key={ticket._id} className="ticket-card-history resolved-ticket">
                                        <h3>{ticket.subject}</h3>
                                        <p>{ticket.description}</p>
                                        <p>Status: {ticket.status}</p>
                                        <p>Remark: {ticket.remark}</p>
                                        <span>
                                            Issue Date & Time: &nbsp;
                                            {new Intl.DateTimeFormat("en-US", {
                                                dateStyle: "medium",
                                                timeStyle: "short",
                                            }).format(new Date(ticket.createdAt))}
                                        </span>
                                        <br />
                                        <span>
                                            Resolved Date & Time: &nbsp;
                                            {new Intl.DateTimeFormat("en-US", {
                                                dateStyle: "medium",
                                                timeStyle: "short",
                                            }).format(new Date(ticket.updatedAt))}
                                        </span>

                                    </div>
                                ))
                            ) : (
                                <p>No resolved or closed tickets.</p>
                            )}
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}

export default FacultyTicketHistory;
